import { check as checkFF } from '@webapp-next/lib/feature-flag';

/**
 * @return {boolean} - whether to require the logged-in user to have
 * multifactor authentication setup
 */
export function requireMfaForPayroll(): boolean {
  return checkFF('payx-488-require-mfa-for-payroll');
}

export function checkPayrollEnabled(): boolean {
  return checkFF('payx-31-enable-payroll');
}

export function isPayrollPaywallDisabledViaFF(): boolean {
  return checkFF('payx-121-payroll-disable-paywall');
}

export function usePayrollEmployeeBulkImportTemplate(): boolean {
  return checkFF('payx-532-use-payroll-employee-bulk-import-template');
}

export function checkLeaveEntitlementSettingsEnabled(): boolean {
  return checkFF('payx-712-leave-entitlement-settings');
}

export function isClosedBetaEnabled(): boolean {
  return checkFF('payx-1039-is-payroll-closed-beta-tenant');
}

export function isBetaEnabled(): boolean {
  return checkFF('payx-1038-au-provider-microkeeper-beta');
}

export function checkPayrollAdvancedPermissionEnabled(): boolean {
  return checkFF('payx-1049-enable-payroll-advanced-permission');
}

export function checkPayrollEmailPayslips(): boolean {
  return checkFF('payx-1275-payroll-email-payslips');
}

export function checkPayrollEOI(): boolean {
  return checkFF('payx-1070-show-payroll-eoi');
}

export function checkPayrollParcelEnabled(): boolean {
  return checkFF('payx-1706-enable-payroll-fe-nomono');
}

export function checkShowMfaInLastStepOnboarding(): boolean {
  return checkFF('payx-1312-mfa-last-step-payroll-onboarding');
}

export function checkPayrollAbnBranching(): boolean {
  return checkFF('payx-1688-enable-payroll-abn-branching');
}
